module.exports = __webpack_public_path__ + "img/shoot_00032.8170aa41.png";